"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _CmsLayout = _interopRequireDefault(require("../components/CmsLayout"));

var _TermForm = _interopRequireDefault(require("../components/TermForm"));

var _ListItem = _interopRequireDefault(require("../components/ListItem"));

var _utils = require("../utils");

var _actions = require("../actions");

var _store = require("../store"); // import app components


var Taxonomy = function Taxonomy(props) {
  var _sites$siteID, _sites$siteID$taxonom, _config$fields, _config$fields$taxono, _config$fields$taxono2;

  var taxonomyID = props.taxonomyID;

  var _ref3 = (0, _store.useStore)(),
      _ref4 = _slicedToArray(_ref3, 2),
      _ref4$ = _ref4[0],
      config = _ref4$.config,
      _ref4$$cmsState = _ref4$.cmsState,
      siteID = _ref4$$cmsState.siteID,
      sites = _ref4$$cmsState.sites,
      dispatch = _ref4[1];

  var _ref5 = (0, _react.useState)(false),
      _ref6 = _slicedToArray(_ref5, 2),
      isSyncing = _ref6[0],
      setIsSyncing = _ref6[1];

  var taxonomy = (_sites$siteID = sites[siteID]) === null || _sites$siteID === void 0 ? void 0 : (_sites$siteID$taxonom = _sites$siteID.taxonomies) === null || _sites$siteID$taxonom === void 0 ? void 0 : _sites$siteID$taxonom[taxonomyID];
  var terms = taxonomy !== null && taxonomy !== void 0 && taxonomy.terms ? (0, _utils.createDataTree)(taxonomy.terms) : [];

  var handleSync = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _sites$siteID2;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSyncing(true);
              _context.next = 3;
              return _actions.siteActions.syncFields({
                fields: config.fields,
                apiKey: (_sites$siteID2 = sites[siteID]) === null || _sites$siteID2 === void 0 ? void 0 : _sites$siteID2.apiKey
              }, dispatch, config);

            case 3:
              setIsSyncing(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSync() {
      return _ref7.apply(this, arguments);
    };
  }();

  var handleUpsert = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
      var id, title, slug, parentID, description;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              id = _ref.id, title = _ref.title, slug = _ref.slug, parentID = _ref.parentID, description = _ref.description;

              if (!id) {
                _context2.next = 6;
                break;
              }

              _context2.next = 4;
              return _actions.termActions.updateTerm({
                siteID: siteID,
                taxonomyID: taxonomyID,
                id: id,
                title: title,
                slug: slug,
                parentID: parentID,
                description: description
              }, dispatch, config);

            case 4:
              _context2.next = 8;
              break;

            case 6:
              _context2.next = 8;
              return _actions.termActions.addTerm({
                siteID: siteID,
                taxonomyID: taxonomyID,
                id: id,
                title: title,
                slug: slug,
                parentID: parentID,
                description: description
              }, dispatch, config);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleUpsert(_x) {
      return _ref8.apply(this, arguments);
    };
  }();

  var handleDelete = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
      var termID;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              termID = _ref2.termID;
              _context3.next = 3;
              return _actions.termActions.deleteTerm({
                siteID: siteID,
                taxonomyID: taxonomyID,
                id: termID
              }, dispatch, config);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleDelete(_x2) {
      return _ref9.apply(this, arguments);
    };
  }();

  var handleOpenDialog = function handleOpenDialog(term) {
    dispatch({
      type: 'SET_DIALOG',
      payload: {
        open: true,
        title: "Term",
        component: /*#__PURE__*/_react.default.createElement(_TermForm.default, (0, _extends2.default)({}, term, {
          terms: taxonomy === null || taxonomy === void 0 ? void 0 : taxonomy.terms,
          onSubmit: handleUpsert
        }))
      }
    });
  };

  var renderTerm = function renderTerm(o, level) {
    var actions = [];
    actions.push( /*#__PURE__*/_react.default.createElement(_antd.Popconfirm, {
      title: "Are you sure?",
      onConfirm: function onConfirm() {
        return handleDelete({
          termID: o.id
        });
      },
      okText: "Yes",
      cancelText: "No"
    }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
      size: "small",
      children: "Delete",
      danger: true
    })));
    actions.push( /*#__PURE__*/_react.default.createElement(_antd.Button, {
      size: "small",
      children: "Edit",
      onClick: function onClick() {
        return handleOpenDialog(o);
      }
    }));
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: o.id
    }, /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      level: level,
      actions: actions,
      title: o.title,
      subtitle: o.slug
    }), o.childNodes.map(function (p) {
      return renderTerm(p, level + 1);
    }));
  };

  return /*#__PURE__*/_react.default.createElement(_CmsLayout.default, {
    pageTitle: (config === null || config === void 0 ? void 0 : (_config$fields = config.fields) === null || _config$fields === void 0 ? void 0 : (_config$fields$taxono = _config$fields.taxonomies) === null || _config$fields$taxono === void 0 ? void 0 : (_config$fields$taxono2 = _config$fields$taxono.find(function (o) {
      return o.id === taxonomyID;
    })) === null || _config$fields$taxono2 === void 0 ? void 0 : _config$fields$taxono2.title) || (taxonomy === null || taxonomy === void 0 ? void 0 : taxonomy.title)
  }, /*#__PURE__*/_react.default.createElement(_antd.PageHeader, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: "Add",
    onClick: function onClick() {
      return handleOpenDialog();
    },
    type: "primary",
    disabled: !taxonomy
  })), !taxonomy && /*#__PURE__*/_react.default.createElement(_antd.Alert, {
    message: "Unknown taxonomy",
    description: "Restart the development process or sync new data now",
    type: "info",
    showIcon: true,
    action: /*#__PURE__*/_react.default.createElement(_antd.Button, {
      size: "small",
      type: "ghost",
      onClick: handleSync,
      loading: isSyncing
    }, "Sync to WordPress")
  }), /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 8
  }, terms && terms.map(function (item) {
    return renderTerm(item, 0);
  })));
};

var _default = Taxonomy;
exports.default = _default;